import { Sparkles, Phone } from "lucide-react";
import { COMBO } from "@/lib/prices";
import { STUDIO } from "@/lib/studio";
import { Reveal } from "../Reveal";

export const ComboCard = ({ onBook }) => (
  <section id={COMBO.id} data-testid="price-category-kombination" className="scroll-mt-32 py-8 lg:py-12">
    <Reveal className="relative overflow-hidden rounded-[36px] bg-espresso px-6 py-12 text-cream sm:px-12 lg:px-16 lg:py-16">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full border border-gold-light/25" />
      <div className="pointer-events-none absolute -right-10 -top-10 h-72 w-72 rounded-full border border-gold-light/15" />
      <div className="relative grid gap-10 lg:grid-cols-[1.3fr_0.7fr] lg:items-end">
        <div>
          <div className="flex items-center gap-4 text-[11px] font-medium uppercase tracking-[0.32em] text-gold-light">
            <span className="font-serif text-base normal-case italic tracking-normal">07</span>
            <span className="h-px w-10 bg-gold-light/50" />
            <span>Exklusive Kombinationsbehandlung</span>
          </div>
          <h2 className="mt-6 font-serif text-4xl leading-[1.05] sm:text-5xl lg:text-6xl">
            Korean Skin Renewal <span className="italic text-gold-light">&amp; G8 Body Sculpt Ritual</span>
          </h2>
          <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-cream/85">{COMBO.desc}</p>
          <p className="mt-4 flex items-start gap-2 text-sm text-cream" data-testid="price-consult-kombination">
            <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-gold-light" strokeWidth={1.6} /> {COMBO.consult}
          </p>
        </div>
        <div className="flex flex-col gap-5 lg:items-end">
          <p className="font-serif text-6xl text-gold-light sm:text-7xl" data-testid="price-combo-price">{COMBO.price}</p>
          <button onClick={() => onBook(COMBO.title)} data-testid="price-combo-book-btn" className="btn-gold rounded-full px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.22em]">
            Termin vereinbaren
          </button>
          <a href={STUDIO.phoneHref} data-testid="price-combo-call-btn" className="inline-flex items-center justify-center gap-2 text-sm text-cream/85 hover:text-cream">
            <Phone className="h-4 w-4" /> <span className="link-underline">{STUDIO.phone}</span>
          </a>
        </div>
      </div>
    </Reveal>
  </section>
);
